import { useEffect } from 'react';
/**
 *
 * @param onMouse Callback function to register with mouse events
 * - Consider using a memoized function to avoid excessive registering and unregistering mouse events
 */
export default function useMouseEvent(onMouse) {
    // Add event listeners
    useEffect(() => {
        window.addEventListener('touchmove', onMouse);
        window.addEventListener('mousewheel', onMouse);
        window.addEventListener('mousemove', onMouse);
        window.addEventListener('click', onMouse);
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener('touchmove', onMouse);
            window.removeEventListener('mousewheel', onMouse);
            window.removeEventListener('mousemove', onMouse);
            window.removeEventListener('click', onMouse);
        };
    }, [onMouse]); // Empty array ensures that effect is only run on mount and unmount
}
//# sourceMappingURL=useMouseEvent.js.map